import {

  ACTIVATING_CHAT_INTEGRATION_REQUEST, ACTIVATING_CHAT_INTEGRATION_SUCCEDDED, ACTIVATING_CHAT_INTEGRATION_FAILED,
  UPDATING_CHAT_INTEGRATION_REQUEST, UPDATING_CHAT_INTEGRATION_SUCCEDDED, UPDATING_CHAT_INTEGRATION_FAILED,
} from '../../actions/actionTypes.jsx';

import { combineReducers } from 'redux';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  activation: {
    activating: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  }
};

function chatIntegrationReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIVATING_CHAT_INTEGRATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: true,
          error: null
        }
      })
    case ACTIVATING_CHAT_INTEGRATION_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: null
        }
      })
    case ACTIVATING_CHAT_INTEGRATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        activation: {
          activating: false,
          error: action.payload
        }
      })

    case UPDATING_CHAT_INTEGRATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: true,
          error: null
        }
      })
    case UPDATING_CHAT_INTEGRATION_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: null
        }
      })
    case UPDATING_CHAT_INTEGRATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          saving: false,
          error: action.payload
        }
      })
    default:
      return state
  }
}

export { chatIntegrationReducer };